import styled from 'styled-components';
import colors from 'styles/colors';
import { InsuranceStatus } from 'store/modules/conlicitaseg_store/types';

export const ClearButton = styled.button`
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
`;

interface StatusBadgeProps {
  statusType?: InsuranceStatus;
}

export const StatusBadge = styled.span<StatusBadgeProps>`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  color: white;

  ${({ statusType }) => {
    switch (statusType) {
      case 'cotacao':
        return `
          background-color: ${colors.$gray600};
          color: white;
        `;
      case 'analise':
        return `
          background-color: ${colors.$warning};
          color: black;
        `;
      case 'emitida':
        return `
          background-color: ${colors.$success};
          color: white;
        `;
      case 'vigente':
        return `
          background-color: ${colors.$success};
          color: white;
        `;
      case 'recusada':
        return `
          background-color: ${colors.$danger};
          color: white;
        `;
      case 'cancelada':
        return `
          background-color: ${colors.$danger};
          color: white;
        `;
      case 'encerrada':
        return `
          background-color: ${colors.$gray600};
          color: ${colors.$black};
        `;
      case 'expirada':
        return `
          background-color: ${colors.$warning};
          color: black;
        `;
      default:
        return `
          background-color: ${colors.$gray600};
          color: white;
        `;
    }
  }}
`;

export const StateIcon = styled.i`
  font-size: 100px;
`;
